module.exports = __webpack_public_path__ + "static/img/82-2.06c44bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/82-2.jpg
// module id = yWii
// module chunks = 0